/**
 * "Ongedaan maken" voor destructieve klikjes (afvinken, verwijderen): een toast met knop
 * plus Ctrl+Z / Cmd+Z voor de laatste actie (Joris, 6 sep). Per pagina één registratie.
 */
import { createElement } from 'react';
import toast from 'react-hot-toast';

let laatste = null; // { herstel: async fn, toastId }

/**
 * Opt-in `eigenKnop: true`: de toastknop draait zijn EIGEN actie terug in plaats van
 * de globale laatste (Codex 26 sep: bij twee verborgen gesprekken herstelde de knop van
 * A het gesprek B). Alleen voor acties die positie-onafhankelijk herstellen; het
 * standaardgedrag (knop = Ctrl+Z = laatste actie) blijft voor alle andere schermen.
 */
export function biedOngedaanAan(tekst, herstel, { duur = 8000, eigenKnop = false } = {}) {
  const id = toast((t) => createElement('span', { style: { display: 'inline-flex', alignItems: 'center', gap: 12 } },
    tekst,
    createElement('button', {
      onClick: async () => { toast.dismiss(t.id); await (eigenKnop ? herstelEigen(t.id, herstel) : voerOngedaanUit()); },
      style: { border: 0, background: '#1e3a8a', color: '#fff', borderRadius: 6, padding: '4px 10px', fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' },
    }, 'Ongedaan maken (Ctrl+Z)')), { duration: duur, icon: '✔' });
  laatste = { herstel, toastId: id };
  setTimeout(() => { if (laatste?.toastId === id) laatste = null; }, duur);
  return id;
}

const herstelde = new Set(); // toast-ids die al zijn teruggedraaid (nooit twee keer)

async function herstelEigen(toastId, herstel) {
  if (toastId != null) {
    if (herstelde.has(toastId)) return false;
    herstelde.add(toastId);
  }
  if (laatste?.herstel === herstel) laatste = null;
  try { await herstel(); toast.success('Ongedaan gemaakt'); return true; }
  catch (e) { toast.error(`Ongedaan maken mislukt: ${e.message || e}`); return false; }
}

export async function voerOngedaanUit() {
  if (!laatste) return false;
  const { herstel, toastId } = laatste; laatste = null;
  // Alleen met een echt toast-id bijhouden (in tests/mocks kan het ontbreken).
  if (toastId != null) {
    if (herstelde.has(toastId)) return false;
    herstelde.add(toastId);
  }
  toast.dismiss(toastId);
  try { await herstel(); toast.success('Ongedaan gemaakt'); return true; }
  catch (e) { toast.error(`Ongedaan maken mislukt: ${e.message || e}`); return false; }
}

/** Hang aan een pagina: Ctrl+Z / Cmd+Z buiten tekstvelden = laatste actie terugdraaien. */
export function registreerOngedaanSneltoets() {
  const handler = (e) => {
    if (!(e.key === 'z' || e.key === 'Z') || !(e.ctrlKey || e.metaKey) || e.shiftKey) return;
    const tag = (document.activeElement?.tagName || '').toLowerCase();
    if (tag === 'input' || tag === 'textarea' || document.activeElement?.isContentEditable) return;
    if (!laatste) return;
    e.preventDefault();
    voerOngedaanUit();
  };
  window.addEventListener('keydown', handler);
  return () => window.removeEventListener('keydown', handler);
}
